import React, { useEffect } from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { reverseFormatDate } from '../../../utils/dateFunctions';
import { downloadCsv } from '../../../utils/downloadCSV';
import DataSetsResultsModal from '../DataSetsResultsModal';

const fileName = 'CTW Referrals';
const fields =
    'PT_ID,NINO,First_Name,Middle_Name,Last_Name,Date_of_Birth,Eligibility_Group,Address_Line_1,Address_Line_2,Town/City,Postcode,Phone,Email,PT_Status';

const WAIT = 5000;

const CreateCTWReferralsCsv = ({ isOpen, onClose, rows }) => {
    // USE EFFECTS
    useEffect(() => {
        const values = Object.values(
            rows.map((el) => {
                // eslint-disable-next-line
                const { rowId, ...rest } = el;
                const formattedRow = {
                    ...rest,
                    dateOfBirth: reverseFormatDate(el.dateOfBirth)
                };
                return Object.values(formattedRow);
            })
        );

        const name = `${fileName}_${format(new Date(), `dd_MMM_yyyy_HH_mm`)}`;
        downloadCsv(fields, values, name);
        const timerId = setTimeout(() => onClose(), WAIT);
        return () => clearTimeout(timerId);

    }, [rows]);

    // RENDER
    return (
        <DataSetsResultsModal
            isOpen={isOpen}
            onCancel={onClose}
            resultRowsLength={rows.length || 0}
            dataSetName="CTW Referrals"
        />
    );
};

CreateCTWReferralsCsv.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    rows: PropTypes.arrayOf(PropTypes.object)
};

export default CreateCTWReferralsCsv;
